import { breakpoints } from 'configs';

// eslint-disable-next-line no-prototype-builtins
const isBreakpoint = (value) => breakpoints.hasOwnProperty(value);

export default isBreakpoint;
